import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Crown, ChevronRight } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
const GOLD = '#c9a962';

export const FoundingTenTicker = () => {
  const navigate = useNavigate();
  const [wall, setWall] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/founding-ten/wall`)
      .then(r => r.ok ? r.json() : null)
      .then(d => d && setWall(d))
      .catch(() => {});
  }, []);

  if (!wall || !wall.active || wall.slots_left <= 0) return null;

  const daysLeft = Math.max(0, Math.ceil((new Date(wall.ends_at) - Date.now()) / 86400000));

  return (
    <button
      onClick={() => navigate('/founders-wall')}
      className="w-full flex items-center justify-center gap-2 px-4 py-2.5 transition-opacity hover:opacity-90"
      style={{ backgroundColor: '#14100e', borderBottom: `1px solid rgba(201,169,98,0.35)` }}
      data-testid="founding-ten-ticker"
    >
      <Crown className="w-3.5 h-3.5 shrink-0" style={{ color: GOLD }} />
      <span className="text-[11px] sm:text-xs tracking-wide" style={{ color: '#f0e9df' }}>
        <span className="font-semibold" style={{ color: GOLD }}>The Founding Ten</span>
        {' · '}
        <span className="font-semibold" data-testid="founding-ten-ticker-slots">{wall.slots_left} of 10 slots left</span>
        {' · '}{daysLeft} days to claim lifetime 0% fees
      </span>
      <ChevronRight className="w-3.5 h-3.5 shrink-0" style={{ color: GOLD }} />
    </button>
  );
};
